module.exports = __webpack_public_path__ + "images/emoji/recycle.8523015ed17527e5f17c.png";